var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M22,9V6H17.917L18.742.5H15.708L14.883,6H10.917L11.742.5H8.708L7.883,6H3V9H7.433l-.9,6H2v3H6.083l-.825,5.5H8.292L9.117,18h3.966l-.825,5.5h3.034l.825-5.5H21V15H16.567l.9-6Zm-8.467,6H9.567l.9-6h3.966Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }